import { useT } from "@transifex/react";
import { useGeneralContext } from "../../context/AppGeneralContext";
import { AreaButton, ButtonColorVariant, ButtonVariant } from "../../complex/teacherArea/AreaButton";
import { useLogger } from "../../hooks/useLogger";
import { cp } from "../../config";

interface HeaderBurgerMenuLoginLogoutButtonProps {
    isUser: boolean;
    onLogout?: () => void;
}

const HeaderBurgerMenuLoginLogoutButton = (props: HeaderBurgerMenuLoginLogoutButtonProps) => {
    const { logoutUser } = useGeneralContext();
    const { logEvent } = useLogger();

    const t = useT();

    const t_logout = t("Logout", { _tags: "TeacherArea,Header" });
    const t_login = t("Login", { _tags: "TeacherArea,Header" });

    const handleLogout = async () => {
        logEvent("Logout Button Clicked", { source: "mobile" });
        await logoutUser();
        props.onLogout?.();
    };

    return (
        <div className="py-s px-m gap-xs flex w-full flex-col border-none">
            {props.isUser ? (
                <AreaButton
                    role="button"
                    buttonId="header-burger-logout"
                    variant={ButtonVariant.SECONDARY}
                    colorVariant={ButtonColorVariant.LUMINA}
                    onClick={handleLogout}
                >
                    {t_logout}
                </AreaButton>
            ) : (
                <AreaButton
                    role="link"
                    buttonId="header-burger-login"
                    variant={ButtonVariant.SECONDARY}
                    colorVariant={ButtonColorVariant.LUMINA}
                    href={`${cp.cfg.REACT_APP_P6_BASE_WEBSITE}classic/service/user/login.html`}
                    onClick={() => {
                        logEvent("Login Button Clicked", { source: "mobile" });
                    }}
                >
                    {t_login}
                </AreaButton>
            )}
        </div>
    );
};

export default HeaderBurgerMenuLoginLogoutButton;
